import { useEffect, useState } from 'react';
import { getPublicSettings } from '../api/payment/system.api';

// Cấu hình công khai: feature flags (bool) + chung/thương hiệu (string).
// Fetch 1 lần, cache module-level, chia sẻ cho mọi component.
// Flag mặc định BẬT khi chưa tải/không rõ (tránh nháy ẩn tính năng); chỉ ẩn khi = "false" rõ ràng.
type Raw = Record<string, string>;

let cache: Raw | null = null;
let inflight: Promise<Raw> | null = null;
const listeners = new Set<(f: Raw) => void>();

const load = (): Promise<Raw> => {
  if (cache) return Promise.resolve(cache);
  if (!inflight) {
    inflight = getPublicSettings()
      .then((raw) => {
        cache = raw || {};
        listeners.forEach((l) => l(cache!));
        return cache;
      })
      .catch(() => {
        cache = {};
        return cache;
      });
  }
  return inflight;
};

export const useFeatureFlags = () => {
  const [vals, setVals] = useState<Raw>(cache || {});
  useEffect(() => {
    let mounted = true;
    load().then((f) => mounted && setVals(f));
    const l = (f: Raw) => mounted && setVals(f);
    listeners.add(l);
    return () => {
      mounted = false;
      listeners.delete(l);
    };
  }, []);
  const isOn = (key: string) => vals[key] !== 'false'; // chưa rõ → coi như bật
  const get = (key: string) => vals[key] ?? ''; // giá trị string (branding...)
  return { vals, isOn, get };
};
